import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-question-with-options",
  templateUrl: "./question-with-options.component.html",
  styleUrls: ["./question-with-options.component.scss"],
  standalone: false
})
export class QuestionWithOptionsComponent implements OnInit {
  @Input() question: string = "";
  @Input() optionsTitle: string = "";
  @Input() options: any[] = []; //todo: change type
  @Input() selectedOptions: number[] = [];
  @Output() selectedOptionsChange = new EventEmitter<number[]>();

  ngOnInit() {}

  isSelected(id: number): boolean {
    return this.selectedOptions.includes(id);
  }

  toggleOption(id: number): void {
    const next = this.isSelected(id) ? this.selectedOptions.filter((v) => v !== id) : [...this.selectedOptions, id];
    this.selectedOptionsChange.emit(next);
  }
}
